<template>
    <!-- 클릭으로 바꾸기
    <div>
      <template v-for="(lang, key) in langs">
        <span :key="lang.flags" style="width: 45px; cursor: pointer; height: 45px; margin: 0px 5px;" class="flag-icon" :class="flags(lang.flags)" @click="setLang(key)"></span>
      </template> -->
      <!-- <template>
        <ul class="navbar-nav topbar-nav ml-md-auto align-items-center">
          <li class="nav-item dropdown hidden-caret">
            <a class="nav-link dropdown" href="javascript:void(0)" id="messageDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              <span class="flag-icon" :class="flags(lang)" style="width: 30px; cursor: pointer; height: 30px;" @click="language()"></span>
            </a>
          </li>
        </ul>
      </template> -->

    <!-- 드롭다운으로 바꾸기 -->
  <div>
    <template>
      <a class="nav-link dropdown" href="javascript:void(0)" id="messageDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
        <span class="flag-icon" :class="flags(lang)" style="width: 30px; cursor: pointer; height: 30px;"></span>
      </a>
      <ul class="dropdown-menu notif-box animated fadeIn" aria-labelledby="notifDropdown" style="width:100px;">
        <li>
          <div class="notif-center" v-for="(lang, key) in langs" @click="setLang(key)">
            <a href="javascript:void(0)">
              <div class="notif-icon">
                <span :key="lang.flags" style="width: 30px; cursor: pointer; height: 30px; margin: 0px 5px;" class="flag-icon" :class="flags(lang.flags)" @click="setLang(key)"></span>
              </div>
              <div class="notif-content ml-3" v-if="e_lang == 'English'">
                <span class="block" style="font-size : 1em;" v-if="key == 'EN'">{{e_lang ? 'English' : ''}}</span>
                <span class="block" style="font-size : 1em;" v-if="key == 'KO'">{{e_lang ? 'Korean' : ''}}</span>
              </div>
              <div class="notif-content ml-3" v-else-if="e_lang == '한국어'">
                <span class="block" style="font-size : 1em;" v-if="key == 'EN'">{{e_lang ? '영어' : ''}}</span>
                <span class="block" style="font-size : 1em;" v-if="key == 'KO'">{{e_lang ? '한국어' : ''}}</span>
              </div>
            </a>
            <div class="dropdown-divider"></div>
          </div>
        </li>
      </ul>
    </template>
  </div>
</template>

<script>
import 'flag-icon-css/css/flag-icon.css';

import { SetLang, GetLang } from '@/service/i18n'

export default {
  data: () => ({ langs : [], lang : '', past_lang : '', e_lang : ''}),
  methods: {
    setLang(lang) { SetLang(lang); },
    flags(lang) { return `flag-icon-${lang.toLowerCase()}`; },
    load(){
      let lang = SetLang(localStorage['UWSS_MANAGER_LANG'] || 'EN');

      //언어 바꾸기
      this.change();

      if(lang == 'EN'){
        this.lang = this.past_lang;
      }else{
        this.lang = this.past_lang;
      }

      // ko -> kr / en -> us (드롭다운일때)
      this.flag(lang)

      //test
      this.name(lang)
      this.e_lang = this.name(lang)

      // ko -> us / en -> kr (클릭일때)
      // this.flag(this.lang)
    },
    flag(lang){
      let country = this.langs[lang].flags
      this.lang = country;
    },
    language(){
      let lang = SetLang(localStorage['UWSS_MANAGER_LANG'] || 'EN');

      if(lang == 'EN'){
        // this.lang = 'KO'
        this.lang = this.past_lang
      }else{
        // this.lang = 'EN'
        this.lang = this.past_lang
      }

      SetLang(this.lang);
    },
    change(){
      let lang = SetLang(localStorage['UWSS_MANAGER_LANG'] || 'EN');

      //과거 lang
      this.past_lang = lang

      let key = Object.keys(this.langs);

      for(let i = 0; i < key.length; i++){
        if(lang != key[i]){
          this.past_lang = key[i]
        }
      }
      return this.past_lang
    },
    name(lang){
      let name = this.langs[lang].desc
      return name
    }
  },
  mounted() {
    this.langs = GetLang();
    this.load();
  },
};
</script>